import { useEffect, useState } from "react";
import { api, fmt$ } from "@/lib/api";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState([]);
  const [size, setSize] = useState("Sedan");

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data));
  }, []);

  const priceRow = (svc) => {
    const s = svc.sizes.find((x) => x.size === size) || svc.sizes[0];
    const promoActive = svc.promo_active && s?.promo_price;
    return { regular: s?.regular_price, promo: s?.promo_price, promoActive };
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Services & Pricing</div>
      <h1 className="font-display text-4xl sm:text-5xl mt-2">Detail packages built for every vehicle</h1>
      <p className="text-zinc-400 mt-3 max-w-2xl">Starting prices - final quote may vary based on vehicle condition.</p>

      <div className="mt-6 flex gap-2 flex-wrap">
        {["Sedan", "SUV", "Truck"].map((sz) => (
          <button
            key={sz}
            data-testid={`size-tab-${sz.toLowerCase()}`}
            onClick={() => setSize(sz)}
            className={`px-4 py-2 rounded-full text-xs uppercase tracking-widest font-semibold border transition
              ${size === sz ? "bg-[#CCFF00] text-black border-[#CCFF00]" : "border-zinc-700 text-zinc-300 hover:border-[#CCFF00]"}`}
          >
            {sz}
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {services.map((svc) => {
          const p = priceRow(svc);
          return (
            <div key={svc.id} className="card-surface card-hover p-6 flex flex-col" data-testid={`service-card-${svc.id}`}>
              <div className="text-xs uppercase tracking-widest text-[#CCFF00]">{svc.deposit_percent}% deposit</div>
              <h3 className="font-display text-3xl mt-2">{svc.name}</h3>
              <p className="text-zinc-400 mt-2 text-sm min-h-[3rem]">{svc.description}</p>
              <div className="mt-4 flex items-end gap-3">
                {p.promoActive ? (
                  <>
                    <span className="font-display text-4xl text-[#CCFF00]">{fmt$(p.promo)}</span>
                    <span className="line-through text-zinc-500 text-lg mb-1">{fmt$(p.regular)}</span>
                  </>
                ) : (
                  <span className="font-display text-4xl">{fmt$(p.regular)}</span>
                )}
              </div>
              <div className="text-xs text-zinc-500 mt-1">Starting price for {size}</div>
              <div className="mt-4 flex items-center gap-2 text-zinc-400 text-sm">
                <Clock size={14} /> {svc.duration_minutes} minutes
              </div>
              <Link
                to={`/book?service=${svc.id}&size=${encodeURIComponent(size)}`}
                data-testid={`service-book-btn-${svc.id}`}
                className="mt-6 neon-btn px-4 py-3 rounded-xl inline-flex items-center justify-center gap-2 text-sm"
              >
                Book this service <ArrowRight size={16} />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
